import React, { useState } from 'react';
import axios from 'axios';
import SearchBar from './searchBar';
import '../styles/return.css';
import { Link } from 'react-router-dom';

const MovieReturn = () => {
  const [movies, setMovies] = useState([]);
  const imageBaseUrl = 'https://image.tmdb.org/t/p/w500'; // This is an example base URL for TMDB images

  // This function will be passed down to SearchBar as the onSearch prop
  const onSearch = async (searchTerm) => {
    try {
      const apiKey = process.env.REACT_APP_TMDB_API_KEY; // Make sure this is correctly set in your .env file
      const response = await axios.get(`https://api.themoviedb.org/3/search/movie?api_key=133b03fa38dce6887c1086a85641ce9a&query=${searchTerm}`);
      setMovies(response.data.results);
    } catch (error) {
      console.error("Error searching movies: ", error);
    }
  };

  return (
    <div className='return'>
      {/* Pass the onSearch function as a prop to the SearchBar component */}
      <SearchBar onSearch={onSearch} />
      <ul className='Mlist'>
  {movies.map(movie => (
   <li key={movie.id} className="movie-item">
    <Link to={`/movie/${movie.id}`}>
   <div className="movie-container">
     <img className="mov" src={`${imageBaseUrl}${movie.poster_path}`} alt={movie.title} />
     <div className='Mname'>{movie.title}</div>
   </div>
   </Link>
 </li>
  ))}
</ul>
    </div>
  );
};

export default MovieReturn;
